var GoalDataModel = /** @class */ (function () {
    function GoalDataModel(resource, id, goalType, goal, action, status, progress, startDate, targetDate, modificationDate, notes, notesList, createdDate, current_version, isCustomGoal) {
        if (id === void 0) { id = ''; }
        if (goalType === void 0) { goalType = ''; }
        if (goal === void 0) { goal = ''; }
        if (action === void 0) { action = ''; }
        if (status === void 0) { status = ''; }
        if (progress === void 0) { progress = 0; }
        if (startDate === void 0) { startDate = ''; }
        if (targetDate === void 0) { targetDate = ''; }
        if (modificationDate === void 0) { modificationDate = ''; }
        if (notes === void 0) { notes = ''; }
        if (notesList === void 0) { notesList = '[]'; }
        if (createdDate === void 0) { createdDate = ''; }
        if (current_version === void 0) { current_version = 0; }
        if (isCustomGoal === void 0) { isCustomGoal = false; }
        this.id = '';
        this.goalType = '';
        this.goal = '';
        this.action = '';
        this.status = '';
        this.progress = 0;
        this.startDate = '';
        this.targetDate = '';
        this.modificationDate = '';
        this.notes = '';
        this.notesList = '[]';
        this.createdDate = '';
        this.current_version = 0;
        this.isCustomGoal = false;
        if (resource) {
            this.resource = resource.map(function (r) { return ({
                resourceId: r.resource_id,
                name: r.name,
                description: r.description,
                date: r.date,
                format: r.format,
                resourceVersion: r.resource_version,
                createdBy: r.created_by,
                lastUpdatedBy: r.last_updated_by,
                lastViewed: r.last_viewed,
            }); });
        }
        else {
            this.resource = [];
        }
        this.id = id;
        this.goalType = goalType;
        this.goal = goal;
        this.action = action;
        this.status = status;
        this.progress = progress;
        this.startDate = startDate;
        this.targetDate = targetDate;
        this.modificationDate = modificationDate;
        this.notes = notes;
        this.notesList = notesList;
        this.createdDate = createdDate;
        this.current_version = current_version;
        this.isCustomGoal = isCustomGoal;
    }
    return GoalDataModel;
}());
export default GoalDataModel;
